<template>
  <div class="box bill-block-component">
    <el-row type="flex" justify="start" :gutter="10">
      <div
        class="info-card"
        v-for="(item, index) in cards"
        :key="index"
        :style="{
          background: `url(${item.bgImg})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right top',
          backgroundSize: '108px 108px'
        }"
      >
        <p class="fz20 color_minor">
          <img style="width:26px;height:26px" :src="item.icon" alt="" />
          {{ item.title }}
        </p>
        <p class="mt30 fw500">
          <!--          <span class=" color_minor_1">累计开票金额</span>-->
          <b class="fz20">{{ item.remoteFieldValue }} {{ item.suffix }}</b>
        </p>
      </div>
    </el-row>

    <invoiceTable />
  </div>
</template>
<script>
import { getStorage, setStorage } from '@/tools/storage';
import { makeSure } from '@/Mixin/makeSure';
import { openTypeList } from '@/config/staticData';
import { invoice } from '@/api/ajax';
import invoiceTable from './child/invoiceTable';
import '@/styles/base.scss';
import Vue from 'vue';

export default {
  name: 'billmgmt',
  cname: '发票管理',
  mixins: [makeSure],
  components: {
    invoiceTable
  },
  data() {
    const { money } = Vue.options.filters;
    return {
      cards: [
        {
          title: '累计开票金额',
          icon: require('@/assets/累计开票金额.svg'),
          bgImg: require('@/assets/累计开票金额02.svg'),
          remoteFieldKey: 'receivedAmount',
          remoteFieldValue: 0,
          remoteFieldValueFilter: v => money(v),
          suffix: '元'
        },
        {
          title: '累计开票数',
          icon: require('@/assets/累计开票数.svg'),
          bgImg: require('@/assets/累计开票数02.svg'),
          remoteFieldKey: 'receivedCount',
          remoteFieldValue: 0,
          suffix: '份'
        },
        {
          title: '待开票金额',
          icon: require('@/assets/待开票金额.svg'),
          bgImg: require('@/assets/待开票金额02.svg'),
          remoteFieldKey: 'submitedAmount',
          remoteFieldValue: 0,
          remoteFieldValueFilter: v => money(v),
          suffix: '元'
        }
      ],
      openTypeList,
      loading: false,
      companyName: getStorage('user').userName,
      account: {},
      order: {},
      billSwitch: 'todo',
      searchQuery: {
        hasPay: 0,
        projectName: this.$route.query.projectName || '',
        orderNo: '',
        payStatus: '',
        taskDt: '2020-01',
        projectStructureType: ''
      },
      totalInfo: {}
    };
  },
  methods: {
    goInfo() {
      this.$router.push({
        name: 'billInfo',
        query: {
          type: 'check'
        }
      });
    },
    async getNum() {
      const {
        data: { data }
      } = await invoice.invoiceStatistics();
      this.totalInfo = data;
      this.cards.forEach((card, index) => {
        let filter = card.remoteFieldValueFilter;
        let fieldV = data[card.remoteFieldKey];
        this.cards[index].remoteFieldValue =
          filter && typeof filter == 'function' ? filter(fieldV) : fieldV;
      });
    }
  },
  async created() {
    // let info = getStorage('billInfo')
    // if (!info || !info.enterpriseIdentifierNo) { //看缓存是否有纳税人号 如果没有就去接口看是否有
    const {
      data: { data }
    } = await invoice.detail();
    if (!data || !data.csoInfo.enterpriseIdentifierNo) {
      this.$router.push({
        name: 'billInfo'
      });
    } else {
      setStorage('billInfo', data.csoInfo);
    }
    // }
    await this.getNum();
  },
  watch: {
    billSwitch(v) {
      this.getNum();
    }
  }
};
</script>
<style lang="scss">
.box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>
<style lang="scss" scoped>
>>> .el-tabs__item.is-active {
  //color: #fff !important;
  //background: rgba(64,158,255,0.78) !important;
  //text-align: center !important;
  //border-radius: 5px 5px 0 0 !important;
  //padding:0 20px!important;
}

.bill-block-component {
  .table-box {
    height: initial;
  }
}
.box {
  height: 100%;
  background: #fff;
  padding: 1rem;
}
.headBox {
  display: flex;
  margin-bottom: 1.88rem;
}
.flexBox {
  display: flex;
  // align-items: center;
}
.countChartBox {
  background: #fff;
  width: 58%;
  margin: 0 1%;
  padding: 1%;
  .first {
    margin-bottom: 1.7rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 1.63rem;
      height: 1.63rem;
      margin-right: 0.63rem;
    }
    span {
      color: #b2b2b2;
      font-size: 1.25rem;
    }
  }
}
#countChart {
  // width: 800px;
  height: 45rem;
  background: #fff;
  margin-bottom: 1.88rem;
  margin-right: 2rem;
}
.btn {
  cursor: pointer;
  width: 7.38rem;
  height: 2.88rem;
  color: #fff;
  font-size: 1rem;
  line-height: 2.88rem;
  text-align: center;
  border-radius: 0.5rem;
}
.company {
  background: #fff;
  width: 30.31rem;
  height: 14rem;
  margin-right: 1.88rem;
  padding: 1.19rem 0 1.25rem 1.88rem;
  border-radius: 0.75rem;
  position: relative;
  box-shadow: 0px 0px 14px 0px rgba(25, 117, 250, 0.2);
  border-radius: 12px;
  .first {
    margin-bottom: 1.7rem;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    img {
      width: 1.63rem;
      height: 1.63rem;
      margin-right: 0.63rem;
    }
    span {
      color: #b2b2b2;
      font-size: 1.25rem;
    }
  }
  > div {
    text-align: left;
  }
  .companyInfo {
    background: rgba(78, 166, 254, 1);
    box-shadow: 0.25rem 0.25rem 0.5rem 0rem rgba(78, 166, 254, 0.5);
  }
}
.account {
  background: #fff;
  width: 40rem;
  height: 14rem;
  margin-right: 2rem;
  border-radius: 0.75rem;
  padding: 1.19rem 0 1.25rem 1.88rem;
  position: relative;
  box-shadow: 0px 0px 14px 0px rgba(25, 117, 250, 0.2);
  border-radius: 12px;
  .first {
    margin-bottom: 1.7rem;
    display: flex;
    align-items: center;
    img {
      width: 1.63rem;
      height: 1.63rem;
      margin-right: 0.63rem;
    }
    span {
      color: #b2b2b2;
      font-size: 1.25rem;
    }
  }
  .second {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 1.5rem;

    span {
      font-size: 0.88rem;
      color: #bfbfbf;
    }
    .accountType {
      width: 8.63rem;
      margin-left: 0.3rem;
      margin-right: 0.3rem;
    }
    h4 {
      font-size: 1.88rem;
      margin-left: 0.3rem;
    }
    h5 {
      font-size: 1rem;
      line-height: 1.25rem;
    }
  }
}
.order {
  background: #fff;
  width: 30rem;
  height: 14rem;
  border-radius: 0.75rem;
  padding: 1.19rem 0 1.25rem 1.88rem;
  position: relative;
  box-shadow: 0px 0px 14px 0px rgba(25, 117, 250, 0.2);
  border-radius: 12px;
  .first {
    margin-bottom: 1.7rem;
    display: flex;
    align-items: center;
    img {
      width: 1.63rem;
      height: 1.63rem;
      margin-right: 0.63rem;
    }
    span {
      color: #b2b2b2;
      font-size: 1.25rem;
    }
  }
  .second {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 1.5rem;
    span {
      font-size: 0.88rem;
      color: #bfbfbf;
    }
    .accountType {
      width: 8.63rem;
      margin-left: 0.3rem;
      margin-right: 0.3rem;
    }
    h4 {
      font-size: 1.88rem;
      margin-left: 0.3rem;
    }
    h5 {
      font-size: 1rem;
      line-height: 1.25rem;
    }
  }
}

.btnPos {
  position: absolute;
  bottom: 20px;
  left: 10px;
}

.info-card {
  box-sizing: border-box;
  padding: 16px 30px;
  width: 360px;
  height: 117px;
  background: #ffffff;
  box-shadow: 6px 6px 16px 0 rgba(25, 117, 250, 0.16);
  border-radius: 12px;
  margin-right: 16px;
}
</style>
